import { useState, useEffect } from 'react';

interface IpInfo {
  ip: string;
  location: {
    country: string;
    region: string;
    city: string;
    latitude: number;
    longitude: number;
  };
}

export const useIpLocation = () => {
  const [ipInfo, setIpInfo] = useState<IpInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchIpInfo = async () => {
      try {
        // Primero obtenemos la IP
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const { ip } = await ipResponse.json();

        // Luego obtenemos la información de ubicación usando la IP
        const locationResponse = await fetch(`https://ipapi.co/${ip}/json/`);
        const locationData = await locationResponse.json();

        if (locationData.error) {
          throw new Error(locationData.reason || 'Error getting location data');
        }

        setIpInfo({
          ip,
          location: {
            country: locationData.country_name,
            region: locationData.region,
            city: locationData.city,
            latitude: locationData.latitude,
            longitude: locationData.longitude,
          },
        });
      } catch (err: any) {
        console.error('Error fetching IP location:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchIpInfo();
  }, []);

  return { ipInfo, loading, error };
};
